import { render } from "./IosCardFr.vue?vue&type=template&id=8d9d7f5e&scoped=true"
import script from "./IosCardFr.vue?vue&type=script&lang=js"
export * from "./IosCardFr.vue?vue&type=script&lang=js"

import "./IosCardFr.vue?vue&type=style&index=0&id=8d9d7f5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d9d7f5e"]])

export default __exports__